$(function () {
  const scrollingProgress = {
    init() {
      scrollingProgress.create();
    },
    create() {
      const ele = $("[data-scrolling-progress]");
      if (ele.length == 0) return;

      $(document).ready(function () {
        scrollingProgress.scrolled(ele);
      });

      $(document).scroll(function () {
        scrollingProgress.scrolled(ele);
      });

      $(window).on('resize', function(){
        scrollingProgress.scrolled(ele);
    });
    },
    scrolled(ele) {
      var h = document.documentElement,
        b = document.body,
        st = "scrollTop",
        sh = "scrollHeight";

      const p = parseInt(
        ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100
      );

      ele.css("width", p + "%");
      ele.attr("aria-valuenow", p);
    },
  };

  scrollingProgress.init();
});
